// overlayKit/EndCard.tsx — channel outro.
// Migrated from ChocolateFullPreview inline EndCard. Brand text is now
// parameterized so non-Factory-Files channels (Jyotirlinga, etc.) can use
// their own. Defaults match Factory Files.
import React from "react";
import { useCurrentFrame, useVideoConfig } from "remotion";
import { appear, FONT, TS, win } from "./utils";
import { useColor } from "./palette";

export type EndCardProps = {
  atS: number;
  outS: number;
  /** Channel header. */
  channel?: string;
  /** 2-line tagline rendered with <br/>. */
  tagline1?: string;
  tagline2?: string;
  /** CTA line. */
  cta?: string;
  /** Palette tokens. */
  channelColor?: string;
  taglineColor?: string;
  ctaColor?: string;
};

export const EndCard: React.FC<EndCardProps> = ({
  atS, outS,
  channel = "FACTORY FILES",
  tagline1 = "WE GO INSIDE",
  tagline2 = "THE FACTORY",
  cta = "SUBSCRIBE · NEW VIDEO EVERY WEEK",
  channelColor = "secondary", taglineColor = "neutral", ctaColor = "primary",
}) => {
  const frame = useCurrentFrame();
  const { fps } = useVideoConfig();
  const t = frame / fps;
  const op = win(t, atS, outS);
  if (op <= 0.001) return null;
  const subOp = appear(t, atS + 0.6, 0.3);
  const chHex = useColor(channelColor);
  const tlHex = useColor(taglineColor);
  const ctaHex = useColor(ctaColor);
  return (
    <div style={{ position: "absolute", top: 18, left: 22, fontFamily: FONT, opacity: op, textAlign: "left" }}>
      <div style={{ color: chHex, fontSize: 26, letterSpacing: "0.3em", marginBottom: 22, textShadow: TS }}>{channel}</div>
      <div style={{ color: tlHex, fontSize: 60, fontWeight: 800, letterSpacing: "-1px", textShadow: TS, lineHeight: 1.12 }}>
        {tagline1}<br />{tagline2}
      </div>
      <div style={{ color: ctaHex, fontSize: 22, letterSpacing: "0.15em", marginTop: 26, textShadow: TS, opacity: subOp }}>{cta}</div>
    </div>
  );
};

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
